import { userRoute } from "pages/user/user.routes"
import { useNavigate } from "react-router-dom"
import styled from "styled-components"
import { SearchClassCard } from "ui/base/class/SearchClassCard"
import { scrollbarStylesThin } from "ui/base/scrollbarStyle/scrollbarStyle"
import { SelectButton } from "ui/base/selectInput/SelectButton"
import { fonts, mediaSizes, themeColor } from "ui/theme"

const options = [
  { value: "popularity", label: "Popularity" },
  { value: "price", label: "Price" },
]

export const ClassSection = ({
  query,
  classes,
  sortBy,
  onSortChange,
  isLoading,
  online_type,
}) => {
  const navigate = useNavigate()

  return (
    <ClassWrapper>
      <ClassHeader>
        <SearchTitle>{query}</SearchTitle>
        <ListingsMeta>
          <ClassHeaderText>
            {classes?.length} instructors available
          </ClassHeaderText>
          <SortContainer>
            <SelectButton
              borderColor='transparent'
              controlledMenu={false}
              showIndicator
              placeholder='Default sorting'
              bgColor='transparent'
              valueColor='txt'
              chevronColor='#191D3A'
              value={sortBy}
              onChange={onSortChange}
              options={options}
              height='40px'
              width='100%'
            />
          </SortContainer>
        </ListingsMeta>
      </ClassHeader>

      <ClassContainer empty={classes.length < 1}>
        {classes.map((item, index) => (
          <SearchClassCard
            key={index}
            classData={item}
            onClick={() =>
              navigate(userRoute.classDetail + item.user_id, {
                state: { online_type },
              })
            }
            online_type={online_type}
          />
        ))}
      </ClassContainer>
    </ClassWrapper>
  )
}

const SearchTitle = styled.h1`
  display: none;

  @media (min-width: 768px) {
    display: block;
    font-family: Poppins, sans-serif;
    font-size: 1.6rem;
    font-weight: 400;
  }
`

const ListingsMeta = styled.div`
  display: flex;
  width: 100%;
  justify-content: flex-end;
  align-items: center;
  gap: 8px;
  flex-shrink: 0;

  @media (min-width: 768px) {
    width: auto;
    justify-content: initial;
  }
`

const ClassWrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 16px;
  flex-grow: 1;
  min-height: 0;

  @media (min-width: 768px) {
    padding-block: 1rem;
  }
`

const ClassContainer = styled.div`
  display: grid;
  grid-template-columns: 1fr;
  gap: 32px 16px;
  
  overflow-y: auto;
  min-height: 78%;

  @media (width >= ${mediaSizes.xs}) {
    grid-template-columns: repeat(2, minmax(0, 1fr));
  }
  @media (width >= ${mediaSizes.md}) {
    padding-right: 1rem;
    grid-template-columns: repeat(3, minmax(0, 1fr));
  }



  ${scrollbarStylesThin}

  /* Fix for not cutting shadows of the images */
  padding-top: 8px;
  margin-top: -8px;
  padding-left: 8px;
  margin-left: -8px;
`

const ClassHeader = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  gap: 12px;
  flex-wrap: wrap;
  padding-bottom: 4px;
`

const ClassHeaderText = styled.p`
  display: none;
  font-family: Poppins, sans-serif;
  color: ${themeColor("txt")};
  font-size: 0.875rem;
  font-weight: 400;
  opacity: 0.7;

  @media (min-width: 768px) {
    display: block;
  }
`

const SortContainer = styled.div`
  min-width: 140px;
  margin-right: -14px;
  --auto-complete-font-size: ${fonts.sizes.small};
  --select-button-font-size: ${fonts.sizes.small};
  font-family: ${fonts.families.primary};
  font-size: ${fonts.sizes.small};
  font-weight: 400;

  .auto-complete__single-value {
    text-align: right;
    padding-right: 2.3rem;
  }

  .auto-complete__single-value,
  .auto-complete__placeholder {
    font-family: ${fonts.families.primary};
    font-size: inherit;
    font-weight: 400;
  }
`
